import React from 'react'

const Loading=()=>{
return(
    <div><img src="https://flevix.com/wp-content/uploads/2019/07/Facebook-Loading-Icons.gif" alt="Loading..."></img></div>
)
}
export default Loading;